import { css } from "@emotion/react";
import styled, { ThemedCssCreator } from "../../../../../../config/emotion";
import {
  NotificationIndicatorForTemplate,
  NotificationIndicatorForTemplateProps,
} from "../../../../../atoms/NotificationIndicator";

export const linkCss: ThemedCssCreator = ({ colors }) => css`
  padding: 0.6rem;
  padding-right: 40px;
  min-height: 3.5rem;
  position: relative;
  color: white;
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  border: none;
  background-color: ${colors.primaryColor};
  text-decoration: none;

  @media (max-width: 812px) {
    padding: 0.8em;
    border-bottom: 1px solid #fff;
  }

  &:hover {
    background-color: ${colors.secondaryColor};
    text-decoration: none;
    color: white;
  }
`;

export const containerCss = css`
  width: 100%;

  @media (max-width: 812px) {
    border-bottom: 0.5px solid white;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const NotificationIndicatorNavigation = styled(
  NotificationIndicatorForTemplate
)<NotificationIndicatorForTemplateProps>`
  position: absolute;
  top: 16px;
  right: 20px;
  transform: translate(50%, -50%);
`;
